import tollStations from './toll-stations'
export default {
  tollStations
}
